export const CheckboxState = {
    UNCHECKED: 0,
    CHECKED: 1,
    INDETERMINATE: 2,
}